import { AbstractControl, ValidationErrors } from '@angular/forms';

export class OnlySpacesValidation {
  static validate(control: AbstractControl): ValidationErrors | null {
    const { value } = control;

    if (value && value.length > 0 && value.trim().length === 0) {
      return { onlySpaces: true };
    }

    return null;
  }
}
